import React, { Component, Fragment } from 'react'

import { connect } from 'react-redux'

import ProductCard from './ProductCard'
import Tagging from './Tagging'

class ProductCardContainer extends Component {
  render () {
    return (
      <Fragment>
        <Tagging type='view' {...this.props} />
        <ProductCard {...this.props} />
      </Fragment>
    )
  }
}

const mapStateToProps = ({ productsv2: products }, { sku }) => {
  return products[sku] || {}
}

export default connect(mapStateToProps)(ProductCardContainer)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/ProductCardContainer.js